// libs
import { styled } from '@nykaa/ui-components';

// components
import BaseImage from 'shared/components/ImageV2';
import BaseCarousel from 'shared/components/Carousel';

// constants
import { IMAGE_HEIGHT, IMAGE_WIDTH } from './constants';

export const Placeholder = styled.div`
  margin-right: ${({ theme }) => theme.spacing.spacing100};
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 0;
`;

const selectedCss = `
  &:after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    right: 0;
    height: 3px;
    background: #000;
  }
`;

export const PlaceholderImage = styled.div<{ isSelected: boolean; backgroundImage: string }>`
  position: relative;
  height: ${IMAGE_HEIGHT}px;
  width: ${IMAGE_WIDTH}px;
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};

  &:last-child {
    margin-bottom: 0;
  }

  ${({ isSelected }) => isSelected && selectedCss}

  ${({ backgroundImage, theme }) => `
        background: ${theme.colors.surface20} url(${encodeURI(
    backgroundImage
  )}) center/contain no-repeat;
    `}
`;

export const Carousel = styled(BaseCarousel)<{ carouselHeight: number }>`
  width: ${IMAGE_WIDTH}px;
  height: ${({ carouselHeight }) => carouselHeight}px;
  margin-right: ${({ theme }) => theme.spacing.spacing100};

  @media (min-width: 860px) and (max-width: 1100px) {
    position: absolute;
    left: 20px;
  }
`;

export const imgClassName = 'pdp-selector-img';
export const Image = styled(BaseImage)`
  height: ${IMAGE_HEIGHT}px;
  width: ${IMAGE_WIDTH}px;
  cursor: pointer;
  background-size: contain;

  & .${imgClassName} {
    object-fit: contain;
  }
`;

export const ImageContainer = styled.div<{ isSelected: boolean }>`
  height: ${IMAGE_HEIGHT}px;
  width: ${IMAGE_WIDTH}px;
  position: relative;

  ${({ isSelected }) => isSelected && selectedCss}
`;
